import { useState } from "react";
import HelpModal from "./HelpModal";
import close from "./svg/close.svg";
import contactUs from "./svg/contact-us.svg";

const ContactUs = ({
  text,
  contact,
  phone,
  help,
  setHelp,
  project,
  onSubmit,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <HelpModal
        open={open}
        setOpen={setOpen}
        project={project}
        onSubmit={onSubmit}
      />
      <div className="lmf__floating__contact">
        {help && (
          <span
            className="lmf__floating__contact--need-help"
            onClick={() => setOpen(true)}
          >
            {text}
          </span>
        )}
        <span
          className="lmf__floating__contact--img"
          onClick={() => setOpen(true)}
        >
          <img src={contactUs} alt="" />
        </span>
        {help && (
          <span
            className="lmf__floating__contact--close"
            onClick={() => setHelp(false)}
          >
            <img src={close} alt="" />
          </span>
        )}
      </div>
    </>
  );
};

export default ContactUs;
